'use strict';

exports.__esModule = true;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _theme = require('../../theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toolbar = _styledComponents2.default.div.withConfig({
  displayName: 'Toolbar',
  componentId: 'sc-1a3f0yr-0'
})(['padding:0 16px;min-height:64px;box-sizing:border-box;background-color:#f5f5f5;display:flex;flex-direction:row;justify-content:space-between;align-items:center;color:', ';'], function (props) {
  return (0, _theme.getTheme)(props).typography.color;
});

exports.default = Toolbar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-dev/thread/lib/components/Toolbar/index.js
// module id = 1092
// module chunks = 29